import { FC, useState } from 'react';
import styles from './styles.module.css';
import { CarInDriverOrder } from '../../../../types/carAllocation';
import {
  DirectionsRenderer,
  DirectionsService,
  GoogleMap,
  useJsApiLoader,
} from '@react-google-maps/api';
import { logger } from '../../../../services/logger';

const VIEW_STYLE = {
  width: '100%',
  height: '100%',
};

type Props = {
  formData: CarInDriverOrder;
  user: number | null;
};

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY ?? '';
if (!googleMapsApiKey)
  logger.warn('REACT_APP_GOOGLE_MAP_API_KEY が設定されていません');

const Map: FC<Props> = (props) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    region: 'JP',
    language: 'ja',
  });

  if (!isLoaded) return null;
  return <MapInner {...props} />;
};

const MapInner: FC<Props> = ({ formData, user }) => {
  if (!formData || formData.carAllocations.length === 0 || !user)
    return (
      <div className={styles.noContenScreen}>
        <div className={styles.noContent}>予定がありません</div>
      </div>
    );

  const waypoints = formData.carAllocations.map((carAllocation) => {
    return { location: carAllocation.companyAddress };
  });
  // 最初(出発地)と最後(目的地)は別で指定するため配列から省く
  waypoints.shift();
  waypoints.pop();
  const request = {
    origin: formData.carAllocations[0].companyAddress, // 出発地
    destination:
      formData.carAllocations[formData.carAllocations.length - 1]
        .companyAddress, // 目的地
    waypoints: waypoints, // 経由地
    travelMode: google.maps.TravelMode.DRIVING,
  };

  const [mapResponse, setMapResponse] =
    useState<google.maps.DirectionsResult>();

  const getMap = () => {
    const directionsService = new google.maps.DirectionsService();
    directionsService.route(request, function (response, status) {
      if (response) {
        if (mapResponse) {
          if (
            status === 'OK' &&
            response.geocoded_waypoints &&
            mapResponse.geocoded_waypoints &&
            response.geocoded_waypoints.length !==
              mapResponse.geocoded_waypoints.length
          ) {
            setMapResponse(response);
          }
        } else {
          if (status === 'OK') {
            setMapResponse(response);
          }
        }
      }
    });
  };

  return (
    <GoogleMap
      mapContainerStyle={VIEW_STYLE}
      zoom={17}
      options={{
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      }}
    >
      {mapResponse && (
        <DirectionsRenderer
          options={{
            directions: mapResponse,
          }}
        />
      )}
      <DirectionsService
        options={{
          origin: request.origin,
          destination: request.destination,
          travelMode: request.travelMode,
          optimizeWaypoints: true,
          waypoints: request.waypoints,
        }}
        callback={getMap}
      />
    </GoogleMap>
  );
};

export default Map;
